import React, {useContext} from "react"

export const OrgContext = React.createContext(null);

export default function useOrganization() {
  const org = useContext(OrgContext);

  return org;
}